import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';

import ResultsPagination from './ResultsPagination';

import styles from './_styles/ResultsControls.module.scss';

const allActionCreators = Object.assign({});

export class ResultsControls extends Component {

	render() {
		return <div className={styles.ResultsControls}>
			<div className={styles.controlsWrapper}>
				<div className={styles.titleWrapper}>
					<div className={styles.title}>DDNY Products</div>
					<div className={styles.backWrapper}>
						<Link to={'/ddny'}>
							<div className={`${styles.back} FlexCenterLeft`}>&lt;&nbsp;Back</div>
						</Link>
					</div>
				</div>
				<div className={styles.contorlBar}>
					{this.props.dataCount !== null && (
						<div className={styles.resultsWrapper}>
							<div className={`${styles.value} FlexCenterLeft`}>
								{`${this.props.dataCount?.toLocaleString('en-US')} ${this.props.dataCount === 1 ? 'result' : 'results'}`}
							</div>
						</div>
					)}
					<div className={styles.sortWrapper}>
						{this.props.dataCount !== null && (
							<ResultsPagination
								dataCount={this.props.dataCount}
								currentPage={this.props.currentPage}
								currentPageSize={this.props.currentPageSize}
								setPage={this.props.setPage} />
						)}
					</div>
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ResultsControls);